<script setup lang="ts">
// Mikrofon: hlavní akce aplikace, 64 px, cyan, vždy pod palcem. Klepnutí spustí nahrávání hlasovky,
// další klepnutí ji zastaví a odešle (panel s časovačem je VoiceRecorder).
import { computed } from 'vue'
import { Mic, Square } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { useVoiceStore } from '@/stores/voice'

withDefaults(defineProps<{ size?: 'fab' | 'header' }>(), { size: 'fab' })
const { t } = useI18n()
const voice = useVoiceStore()

const recording = computed(() => voice.status === 'recording')
const busy = computed(() => voice.status === 'requesting' || voice.status === 'uploading')
// Popisek se nemění: stav nahrávání říká `aria-pressed`.
const label = computed(() => t('nav.mic'))

function onClick(): void {
  if (recording.value) void voice.stop()
  else if (!busy.value) void voice.start()
}
</script>

<template>
  <span class="relative inline-flex">
    <button
      type="button"
      class="inline-flex items-center justify-center rounded-pill bg-primary text-on-primary shadow-glow transition hover:bg-primary-hover disabled:opacity-70"
      :class="size === 'fab' ? 'h-fab w-fab' : 'h-tap w-tap'"
      :aria-label="label"
      :aria-pressed="recording"
      :title="label"
      :disabled="busy"
      data-testid="mic"
      @click="onClick"
    >
      <Square v-if="recording" :size="size === 'fab' ? 26 : 20" aria-hidden="true" />
      <Mic v-else :size="size === 'fab' ? 28 : 22" aria-hidden="true" />
    </button>
    <span
      v-if="voice.pendingCount > 0"
      class="pointer-events-none absolute -right-1 -top-1 flex h-6 min-w-6 items-center justify-center rounded-pill border border-warning-border bg-warning-bg px-1 text-xs font-semibold text-warning"
      role="status"
      data-testid="voice-pending"
    >
      {{ voice.pendingCount }}
      <span class="sr-only">{{ t('buddy.voice.pending', voice.pendingCount) }}</span>
    </span>
  </span>
</template>
